const projectPath = '/enrolamiento-3/';
const fullProjectPath = `/enrolamiento-3${window.location.pathname}`;
const dataLayerObject = {
  PERSONAL_DATA_LOADED: {
    event: 'vpv',
    page: `${projectPath}paso1/datos-personales`,
  },
  PERSONAL_DATA_CEDULE_VERIFICATION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Click',
      'eve-lab': 'Continuar',
    },
  },
  PERSONAL_DATA_VERIFIED_CEDULE: {
    event: 'vpv',
    page: `${projectPath}paso1/cedula-verificada`,
  },
  PERSONAL_DATA_CONTINUE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Click',
      'eve-lab': 'Continuar',
    },
  },
  PERSONAL_DATA_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Click',
      'eve-lab': 'Cancelar',
    },
  },
  CONTRATING_PAYMENT_LOADED: {
    event: 'vpv',
    page: `${projectPath}paso2/contratacion-pago`,
  },
  CONTRATING_PAYMENT_DOWNLOAD_CONTRACT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': '%nombre-documento%',
    },
  },
  CONTRATING_PAYMENT_SEND_SMS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': 'Enviar clave por SMS',
    },
  },
  CONTRATING_PAYMENT_CONTINUE: {
    event: 'trigger_event',
    producto: '%envio%',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': 'Ir al pago',
    },
  },
  CONTRATING_PAYMENT_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Click',
      'eve-lab': 'Cancelar',
    },
  },

  BORDE_SEND_SMS_INCORRET_CODE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Código SMS incorrecto',
    },
  },
  BORDE_SEND_SMS_LOCKED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Excedido limite de intentos',
    },
  },
    /* BORDE_SEND_SMS_TIME_OVER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave dinámica SMS Tiempo agotado',
    },
  }, */
  BORDE_WP_CONECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Inconvenientes para conectar con Webpay',
    },
  },
  BORDE_WP_CONECTION_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Inconvenientes para conectar con Webpay - Reintentar',
    },
  },

  BORDE_CANCELED_PAYMENT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Has anulado tu pago',
    },
  },

    BORDE_DECLINED_PAYMENT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Pago sin procesar',
    },
  },

  SUMMARY_LOADED: {
    event: 'vpv',
    page: `${projectPath}paso3/comprobante-adicioanles`,
    monto: '%valor-cuota%',
    cuotas: '%cantidad-cuotas%',
    userid: '%user-id%',
  },

  
  SUMMARY_CLOSE_MODAL_SUCCESSFULL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/pago-exitoso`,
      'eve-cat': 'Click',
      'eve-lab': 'Entendido, continuar',
    },
  },

  SUMMARY_SHOW_DETAILS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Ver detalle',
    },
  },

  SUMMARY_BACK_TO_COOPEUCH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch',
    },
  },

  SURVEY_ABANDONMENT_LOAD: {
    event: 'vpv',
    page: `${projectPath}encuesta-abandono%paso%`,
  },
  SURVEY_ABANDONMENT_SENDING: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': '%ubicacion%',
      'eve-lab': '%opcion-comentario%',
    },
  },
  SURVEY_ABANDONMENT_RETURN: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': 'Click',
      'eve-lab': 'Retomar contratacion',
    },
  },
    SURVEY_ABANDONMENT_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}encuesta-abandono%paso%`,
      'eve-cat': 'Click',
      'eve-lab': 'Retomar contratacion',
    },
  },
  SURVEY_USABILITY_SATISFACTION_LOAD: {
    event: 'vpv',
    page: `${projectPath}paso3/comprobante-adicionales/encuesta-opinion`,
  },
    SURVEY_USABILITY_SATISFACTION_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch.cl',
    },
  },
  SURVEY_USABILITY_SATISFACTION_1: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion1`,
      'eve-cat': 'Click',
      'eve-lab': '%puntuacion-comentario%',
    },
  },
  SURVEY_USABILITY_SATISFACTION_2: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales/encuesta-opinion2`,
      'eve-cat': 'Click',
      'eve-lab': '%puntuacion-comentario%',
    },
  },

  BORDE_NO_TAXES_IN_CHILE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'No paga impuestos en Chile',
    },
  },
  BORDE_NO_TAXES_IN_CHILE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'No paga impuestos en Chile - Entendido',
    },
  },
  BORDE_BLACK_LIST: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Lista negra',
    },
  },
  BORDE_BLACK_LIST_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Lista negra - Entendido',
    },
  },
  
  BORDE_DECEASED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Fallecidos',
    },
  },
  BORDE_DECEASED_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Fallecidos - Entendido',
    },
  },
  BORDE_UNDERAGE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Mayor de 18 años',
    },
  },
  BORDE_UNDERAGE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Mayor de 18 años - Entendido',
    },
  },

  BORDE_LEGAL_PERSON: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'RUT corresponde a persona juridica',
    },
  },
  BORDE_LEGAL_PERSON_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'RUT corresponde a persona juridica - Entendido',
    },
  },

  BORDE_GENERIC_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error',
    },
  },
  BORDE_GENERIC_ERROR_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error - Entendido',
    },
  },
  BORDE_GENERIC_TRANSVERSE_STEP_2: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error',
    },
  },
  BORDE_GENERIC_TRANSVERSE_STEP_2_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso2/contratacion-pago`,
      'eve-cat': 'Error',
      'eve-lab': 'Ha ocurrido un error - Entendido',
    },
  },
  BORDE_GENERIC_ERROR_EXIT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': '%error%',
    },
  },
  BORDE_GENERIC_ERROR_EXIT_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': '%error% - Entendido',
    },
  },
  BORDE_GENERIC_ERROR_EXIT_FLOW: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Continuar ingreso en sucursal',
    },
  },
  BORDE_GENERIC_ERROR_EXIT_FLOW_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': fullProjectPath,
      'eve-cat': 'Error',
      'eve-lab': 'Continuar ingreso en sucursal - Entendido',
    },
  },
  BORDE_ALREADY_MEMBER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ya eres socio Coopeuch',
    },
  },
  BORDE_ALREADY_MEMBER_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ya eres socio Coopeuch - Entendido',
    },
  },
  BORDE_ALREADY_MEMBER_ELECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  BORDE_CUSTOMER_WITH_UNPAID_FEES: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ya eres socio Coopeuch',
    },
  },
  BORDE_CUSTOMER_WITH_UNPAID_FEES_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingreso Pendiente - Entendido',
    },
  },
  BORDE_RECENT_FORMER_PARTNER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Tienes una renuncia vigente',
    }, 
  },
  BORDE_RECENT_FORMER_PARTNER_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Tienes una renuncia vigente - entendido',
    },
  },
  BORDE_FOREIGN: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Contar con residencia definitiva',
    },
  },
  BORDE_FOREIGN_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Contar con residencia definitiva - Entendido',
    },
  },
  BORDE_RESTRICTED_HOURS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Cierre Bancario',
    },
  },
  BORDE_RESTRICTED_HOURS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Cierre Bancario - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Clave unica',
    },
  },
  BORDE_IDENTITY_VALIDATION_ERROR_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Clave unica - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Identidad no puede ser validada',
    },
  },
  BORDE_IDENTITY_VALIDATION_OFFICE_REDIRECTION_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Identidad no puede ser validada - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave unica no disponible',
    },
  },
  BORDE_IDENTITY_VALIDATION_NOT_AVAILABLE_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Clave unica no disponible - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_RETRY: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Reingresa con clave unica',
    },
  },
  BORDE_IDENTITY_VALIDATION_RETRY_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Reingresa con clave unica - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Intentos permitidos',
    },
  },
  BORDE_IDENTITY_VALIDATION_ATTEMPTS_EXCEEDED_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Intentos permitidos - Entendido',
    },
  },
  BORDE_IDENTITY_VALIDATION_GET_QUESTIONS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Preguntas',
    },
  },
  BORDE_IDENTITY_VALIDATION_GET_QUESTIONS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible validar identidad - Preguntas - Entendido',
    },
  },
  BORDE_SIGNATURE_REQUEST_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/contratacion`,
      'eve-cat': 'Error',
      'eve-lab': 'Imposible mostrar tu firma electronica',
    },
  },
  BORDE_SENDING_OFFERS_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Error al enviar solicitud offer',
    },
  },

  BORDE_INPUT_ADDRESS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingresar dirección con número',
    },
  },

  BORDE_INPUT_ADDRESS_UNDERSTOOD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso1/datos-personales`,
      'eve-cat': 'Error',
      'eve-lab': 'Ingresar dirección con número - Entendido',
    },
  },

  SUMMARY_DOWNLOAD_SECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Descargar %Nombre%',
    },
  },
  /* SUMMARY_GO_TO_PRODUCT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso5/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': '%nombre-producto%',
    },
  }, */

  SUMMARY_CLIK_OPTION_DIGITIZE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton%',
    },
  },

  SUMMARY_SELECT_STORE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Descarga %texto-boton%',
    },
  },

  /* SUMMARY_GO_DOWN_APPCOOPEUCH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%marketplace%',
    },
  }, */

  /* SUMMARY_SHOW_REQUEST_IN_PROGRESS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante`,
      'eve-cat': 'Click',
      'eve-lab': 'Ver detalle de solicitud en curso',
    },
  }, */
  SUMMARY_REQUESTS_SMS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Enviar codigo por SMS',
    },
  },
  SUMMARY_SMS_LOCKED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Excedido limite de intentos - Clave',
    },
  },
  SUMMARY_VALIDATE_SMS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'validar y continuar SMS',
    },
  },
  SUMMARY_CREATE_PASSWORD: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Crear y confirmar contraseña',
    },
  },
  SUMMARY_CREATE_PASSWORD_ERROR: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/comprobante-adicionales`,
      'eve-cat': 'Error',
      'eve-lab': 'Error al crear clave',
    },
  },


  CONTRACTS_HIRE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/contratacion`,
      'eve-cat': 'Click',
      'eve-lab': 'Contratar',
    },
  },
  CONTRACTS_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso3/contratacion`,
      'eve-cat': 'Click',
      'eve-lab': 'Cancelar',
    },
  },
  ADDITIONALS_LOADED: {
    event: 'vpv',
    page: `${projectPath}paso4/adicionales`,
    producto: '%oferta%',
  },
  ADDITIONALS_SELECT_OFFER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton% - Adicionales',
    },
  },
  ADDITIONALS_CONTINUE_WITH_OFFER_SELECTED: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Continuar - %selected-offer%',
    },
  },
  ADDITIONALS_MODIFY_SELECTION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Modificar - %selected-offer%',
    },
  },
  ADDITIONALS_ACCEPTATION_OFFER: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton-and-offer%',
    },
  },
  ADDITIONALS_SELECT_CAH_TYPE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%cah-type%',
    },
  },

  ADDITIONALS_OFFICE_SELECT: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_OFFER_ACCEPTATION: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTRACT_CAH: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Contratar y finalizar - Cuenta de Ahorro',
    },
  },
  ADDITIONALS_CONTINUE_SELECT_DRAWAL_OFFICE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTINUE: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%eleccion%',
    },
  },
  ADDITIONALS_CONTINUE_WITHOUT_PRODUCTS: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Mensaje',
      'eve-lab': 'Sin productos adicionales',
    },
  },
  ADDITIONALS_CONTINUE_WITHOUT_PRODUCTS_CLICK: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': '%texto-boton% - sin productos adicionales',
    },
  },
  ADDITIONALS_CANCEL: {
    event: 'trigger_event',
    'event-config': {
      'eve-acc': `${projectPath}paso4/adicionales`,
      'eve-cat': 'Click',
      'eve-lab': 'Volver a Coopeuch',
    },
  },
};

export default dataLayerObject;
